import { StoreApi, UseBoundStore, useStore } from "zustand";
import {
  WhatsAppChatStoreType,
  whatsappChatStore,
} from "./whatsapp-chat-store";
import {
  whatsappChatPersistentStore,
  WhatsAppChatPersistentStoreType,
} from "./whatsapp-chat-persistent-store";

export const useWhatsAppChatStore = useStore.bind(
  null,
  whatsappChatStore.getStore()
) as UseBoundStore<StoreApi<WhatsAppChatStoreType>>;

export const useWhatsAppChatPersistentStore = useStore.bind(
  null,
  whatsappChatPersistentStore.getStore()
) as UseBoundStore<StoreApi<WhatsAppChatPersistentStoreType>>;
